export default __webpack_public_path__ + "static/stepping-d3414377fe1b1ce2dd46b096815da850.svg";